import React, { Component } from "react";
import moment from 'moment';
import MainPagesLayout from '../../PageLayout/MainPagesLayout/MainPagesLayout';
import Table from '../../PageLayout/Table';
import { Breadcrumb, Col, Container, Row, Button, Form } from 'react-bootstrap';
import ApiService from '../../Services/ApiService';
import ReactRouterPropTypes from 'react-router-prop-types';
import UserService from '../../Services/UserService';
import AuthorizeService from '../../ApiAuthorization/AuthorizeService';
import Loading from '../../PageLayout/Loading';
import { LinkTo } from '../../PageLayout/Link/Link';
import ClassicTitledTile from './component/ClassicTitledTile';
import ProjectBasicDescription from './component/ProjectBasicDescription';
import ComputeService from '../../Services/ComputeService';
import Spinner from '../../PageLayout/Spinner';
import History from '../../Router/RouterHistory';
import AppConfig from '../../Configuration/AppConfig';
import ProjectService from '../../Services/ProjectService';
import aml from "images/ms-aml.png";
import board from "images/ms-board.png";
import repo from "images/ms-repo.png";
import teams from "images/ms-teams.png";
import jupyter from "images/jupyter-icon.png";
import rstudio from "images/rstudio-icon.ico";
import jupyterlab from "images/jupyterlab-icon.png";
import nocomputeImg from "images/no_compute.svg";
import logo from "images/codai.svg";
import nocommitImg from "images/no_commit.svg";

class ProjectDetailPage extends Component {
  static propTypes = {
    match: ReactRouterPropTypes.match,
  }

  constructor() {
    super();
    this.ciInProgressStatuses = ['Creating', 'Stopping', 'Starting', 'SettingUp', 'Deleting'];
    this.ciStableStatuses = ['Running', 'Stopped'];
    this.ciErrorStatuses = ['CreateFailed', 'Failed'];
    this.newCiForm = null;
    this.hours = Array.from({ length: 24 }, (value, key) => key);
    this.ciShutDownDefaultHour = 1;
    this.ciShutDownDefaultTimestamp = moment.utc([2000, 1, 1, this.ciShutDownDefaultHour]);
    this.state = {
      isLoading: true,

      availableTags: [],
      availableRoles: [],
      isUserDataScientist: false,
      isDevOpsUser: false,
      isUserAdmin: false,
      isProjectArchive: false,
      archivingProject: false,
      deletingProject: false,
      availableCiVmSizes: [],
      invalidCiNameInput: true,
      newComputeInstance: { name: '', vmSize: '' },
      newCiFormValidated: false,
      newCiFormState: null,
      actionOnCi: []
    };
    this.ciNamePrefix = !AppConfig.Environment.IsProd ? AppConfig.Environment.Code[0] + '-' : '';
    this.ciNameRegex = this.buildCiNameRegex();
  }

  componentDidMount() {
    const id = this.props.match?.params?.id;

    if (id) {
      const apiRequest = [
        ApiService.getProjectDetails(id),
        UserService.IsUserDataScientist(),
        ApiService.getRef(),
        AuthorizeService.getUser(),
        UserService.IsUserAdmin(),
      ];
      Promise.all(apiRequest).then((data) => {
        let stateUpdate = {
          isLoading: false,
          isUserDataScientist: data[1],
          isUserAdmin: data[4],
          isDevOpsUser: data[0].project.projectUsers.findIndex(user => user.user.upn === data[3].preferred_username) !== -1,
          availableRoles: data[2].profileTypeRefs,
          currentUser: data[3],
          availableTags: data[2].tagRefs,
          availableCiVmSizes: data[2].ciVmSizeRefs.sort((cc, bb) => cc.displayOrder - bb.displayOrder).map(c => ({
            value: c.azureVmSizeCode,
            displayName: c.ciVmSizeRefAlias
          })),
          newComputeInstance: { name: '', vmSize: data[2].ciVmSizeRefs.sort((cc, bb) => cc.displayOrder - bb.displayOrder)[0].azureVmSizeCode, enableSsh: false, sshPublicKey: '' },
          projectDetail: data[0].project,
          isProjectArchive: !!data[0].project.projectTags.find(t => t.tagId == 'archive'),
          azureDevOps: data[0].ado,
          azureML: data[0].aml,
          actionOnCi: [],
          isSSHEnable: false,
          isUserProjectAdmin: data[0].project.projectUsers.findIndex(user =>
            (user.profileTypeRefId === 'ADMIN') && user.user.upn === data[3].preferred_username) !== -1
        };

        this.setState(() => stateUpdate);
      })
        .catch((error) => {
          if (error.errorType === "httpStatus" && error.response.status == 403) {
            History.push('/project/' + id);
            clearTimeout(error.errorDisplayTimer);
          }
        });
    }
  }

  deleteProjectCompute = (event, computeInst, index) => {
    const projectId = this.props.match?.params?.id;
    let name = this.state.azureML.computeInstances[index].name;
    let transiv = this.state.actionOnCi;
    transiv.push(name);
    this.setState({ actionOnCi: transiv }, () => {

      ComputeService.confirmDeletion(projectId, computeInst, null,
        () => {
          const aml = this.state.azureML;
          aml.computeInstances[index].status = "Deleting";
          aml.computeInstances[index].autoShutDownUtcTime = null;
          aml.computeInstances[index].isAutoShutDownEnabled = false;
          let newactiononCi = this.state.actionOnCi.filter(ci => ci !== name);
          this.setState({ azureML: aml, actionOnCi: newactiononCi });
        },
        () => {
          const aml = this.state.azureML;
          let newactiononCi = this.state.actionOnCi.filter(ci => ci !== name);
          this.setState({ azureML: aml, actionOnCi: newactiononCi });
        });
    });

    event.preventDefault();
    event.stopPropagation();
  }

  updateProjectComputeState = (event, computeInst, index) => {
    if (this.isStatusStable(computeInst.status)) {
      const projectId = this.props.match?.params?.id;
      let name = computeInst.name;
      let wantToActivate = (computeInst.status !== 'Running');
      let transiv = this.state.actionOnCi;
      transiv.push(name);
      this.setState({ actionOnCi: transiv }, () => {
        ApiService.setStateProjectComputeInstance(projectId, computeInst.name, wantToActivate).then(() => {
          const aml = this.state.azureML;
          aml.computeInstances[index].status = wantToActivate ? "Starting" : "Stopping";
          let newactiononCi = this.state.actionOnCi.filter(ci => ci !== name);
          this.setState({ azureML: aml, actionOnCi: newactiononCi });
        });
      });
    }
    event.preventDefault();
    event.stopPropagation();
  }

  isArchiveAvailable() {
    return (
      (this.state.isUserProjectAdmin || this.state.isUserAdmin) &&
      !this.state.isProjectArchive &&
      this.state.projectDetail.projectMemberRequest.length == 0 &&
      this.state.azureML.computeInstances.filter(computeInst => !this.isStatusStable(computeInst.status)).length == 0
    );
  }

  isStatusInProgress(status) {
    return this.ciInProgressStatuses.indexOf(status) > -1;
  }

  isStatusStable(status) {
    return this.ciStableStatuses.indexOf(status) > -1;
  }

  isStatusError(status) {
    return this.ciErrorStatuses.indexOf(status) > -1;
  }

  hasActionOnCi(computeInst) {
    return this.state.actionOnCi.indexOf(computeInst.name) > -1;
  }

  buildCiNameRegex() {
    let regex = null;
    regex = new RegExp(`^${this.ciNamePrefix}[a-z]{1}[0-9a-z-]{3,20}[a-z]{1}$`);
    return regex;
  }

  validateCiName = (shortName) => {

    let r = this.ciNameRegex.exec(shortName);
    let isConform = r && r.length === 1 && r[0] === shortName;

    let isUsed = this.state.azureML.computeInstances.some(ci => ci.name === shortName);

    return isConform && !isUsed;
  }

  updateNewCi = (field, value) => {
    var newCI = this.state.newComputeInstance;

    if (field === 'name') {
      this.setState({ invalidCiNameInput: !this.validateCiName(value) });
    }
    if (field === 'enableSsh') {
      newCI[field] = !this.state.isSSHEnable;
      this.setState({ isSSHEnable: !this.state.isSSHEnable });
    }
    else {
      newCI[field] = value;
    }

    this.setState({ newComputeInstance: newCI, newCiFormValidated: false });

  }

  startNewCiCreation = () => {
    this.setState({ newCiFormState: "filling" });
  }

  cancelNewCiCreation = () => {
    this.setState({ newCiFormState: null });
  }

  handleNewCiSubmit = (event) => {
    const form = this.newCiForm;

    if (this.state.invalidCiNameInput === false && this.state.newComputeInstance.vmSize.length > 0) {
      if (form.reportValidity() === true) {
        this.setState({ newCiFormState: "creating", newCiFormValidated: true }, () => {
          this.createNewComputeInstance();
        });
      }
    }

    event.preventDefault();
    event.stopPropagation();
  };

  createNewComputeInstance() {
    const projectId = this.props.match?.params?.id;
    ApiService.createProjectComputeInstance(projectId, this.state.newComputeInstance).then((ciCreated) => {
      let amlState = this.state.azureML;
      let beforeInstaces = amlState.computeInstances;
      beforeInstaces.push(ciCreated);
      amlState.computeInstances = beforeInstaces.sort((a, b) => a.name.localeCompare(b.name));
      this.setState({
        azureML: this.state.azureML,
        newCiFormState: null,
        newCiFormValidated: false,
        newComputeInstance: { name: '', vmSize: this.state.availableCiVmSizes[0].value },
        invalidCiNameInput: true
      });
    });
  }

  archiveProject = () => {
    if (!this.isArchiveAvailable()) {
      return;
    }

    ProjectService.archiveProjectConfirm(this.state.projectDetail, () => {
      const newProject = {
        ...this.state.projectDetail,
        projectUsers: this.state.projectDetail.projectUsers.filter(u => u.profileTypeRefId == 'ADMIN'),
        projectTags: [{
          tagId: 'archive',
          tag: this.state.availableTags.find(tagR => tagR.tagRefId === 'archive'),
        }],
      };

      this.setState({
        archivingProject: true,
      });

      let archiveRequest = [
        ApiService.updateProject(newProject),
        ...this.state.azureML.computeInstances.filter(computeInst => computeInst.status == 'Running').map(computeInst => {
          ApiService.setStateProjectComputeInstance(this.state.projectDetail.projectId, computeInst.name, false);
          return undefined;
        }),
      ];

      Promise.all(archiveRequest)
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          window.location.reload();
        });
    });
  }

  deleteProject = () => {
    if ((this.state.isUserProjectAdmin || this.state.isUserAdmin) && this.state.isProjectArchive && this.state.projectDetail.projectMemberRequest.length == 0 && this.state.projectDetail.isActive) {
      ProjectService.deleteProjectConfirm(this.state.projectDetail, () => {
        this.setState({ deletingProject: true });

        const newProject = {
          ...this.state.projectDetail,
          isActive: false,
        };

        ApiService.updateProject(newProject)
          .then(() => {
            History.push('/');
          })
          .catch(() => {
            window.location.reload();
          });
      });
    }
  }

  updateProjectCIShutDown = (event, instance, propertyName, propertyValue) => {

    let currentSchedule = {
      'isAutoShutDownEnabled': instance.isAutoShutDownEnabled,
      'autoShutDownUtcTime': instance.autoShutDownUtcTime ? instance.autoShutDownUtcTime : this.ciShutDownDefaultTimestamp
    };
    switch (propertyName) {
      case 'isAutoShutDownEnabled': {
        currentSchedule.isAutoShutDownEnabled = propertyValue;
        break;
      }
      case 'autoShutDownUtcTime': {
        currentSchedule.autoShutDownUtcTime = moment.utc([2000, 1, 1, propertyValue]);
        break;
      }
      default:
        break;
    }
    //set action on instance
    let transiv = this.state.actionOnCi;
    transiv.push(instance.name);
    this.setState({ actionOnCi: transiv }, () => {
      ApiService.updateProjectCiSchedule(this.state.projectDetail.projectId, instance.name, currentSchedule)
        .then(() => {
          const aml = this.state.azureML;
          let targetCiIndex = aml.computeInstances.findIndex(ci => ci.name == instance.name);
          aml.computeInstances[targetCiIndex] = { ...aml.computeInstances[targetCiIndex], ...currentSchedule };
          let newactiononCi = this.state.actionOnCi.filter(ciName => ciName !== instance.name);
          this.setState({ azureML: aml, actionOnCi: newactiononCi });
        });
    });

    event.preventDefault();
    event.stopPropagation();
  };

  extractUtcHourFromDateTime(dateTime) {
    return moment.utc(dateTime).hour();
  }

  render() {
    const colWidthBtn = this.state.projectDetail?.teamsUrl ? 3 : 4;
    const projectId = this.props.match?.params?.id;
    let formNewCi;
    if (this.state.newCiFormState === "filling")
      formNewCi = (
        <Form noValidate validated={this.state.newCiFormValidated} ref={e => this.newCiForm = e} >
          <Container>
            <Row>
              <Col sd={4}>
                <Form.Group>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    isValid={!this.state.invalidCiNameInput}
                    className={this.state.invalidCiNameInput ? ' is-invalid' : ' is-valid'}
                    placeholder="Enter the compute name"
                    aria-label="Compute name"
                    value={this.state.newComputeInstance.name}
                    onChange={(i) => this.updateNewCi('name', i.target.value)}
                  />
                  <div className='formInputTextHelper'>{(!AppConfig.Environment.IsProd ? (this.ciNamePrefix + ' and ') : '') + '1 letter "0-9 a-z -" on 3-20 characters and 1 letter'}</div>
                </Form.Group>
              </Col>
              <Col sd={4}>
                <Form.Group>
                  <Form.Label>Size</Form.Label>
                  <Form.Control as="select"
                    isValid={this.state.newComputeInstance.vmSize && this.state.newComputeInstance.vmSize.length > 0}
                    required
                    value={this.state.newComputeInstance.vmSize}
                    onChange={(i) => this.updateNewCi('vmSize', i.target.value)}
                  >
                    {this.state.availableCiVmSizes.map((c) => (
                      <option key={c.value} value={c.value}>{c.displayName}</option>
                    ))}
                  </Form.Control>
                  <div className='formInputTextHelper'>Select a size</div>
                </Form.Group>
              </Col>
              <Col sd={4}>
                <Form.Group>
                  <Form.Label>Enable SSH</Form.Label>
                  <Form.Check
                    id={"custom-switch-ssh"}
                    type="switch"
                    checked={this.state.isSSHEnable}
                    onChange={(i) => this.updateNewCi('enableSsh', i.target.value)}
                    label=''
                  />
                </Form.Group>
              </Col>
            </Row>
            {
              this.state.isSSHEnable ? (<Row>
              <Col sd={4}>
                <Form.Group>
                  <Form.Label>SSH public key</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter ssh public key"
                    aria-label="Compute name"
                    value={this.state.newComputeInstance.sshPublicKey}
                    onChange={(i) => this.updateNewCi('sshPublicKey', i.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>): null

            }

          </Container>
        </Form>
      );



    let projectDetailPage;

    if (this.state.isLoading) {
      projectDetailPage = (<Loading />);
    } else {
      projectDetailPage = (
        <>
          <ProjectBasicDescription
            project={this.state.projectDetail}
            projectMarkdownDescription={this.state.azureDevOps.sourceFiles.find(f => f.fileName === 'description.md')}
            availableTags={this.state.availableTags}
            availableRoles={this.state.availableRoles}
            isUserAdmin={(this.state.isUserProjectAdmin || this.state.isUserAdmin)}
            isUserDataScientist={(this.state.isUserProjectAdmin || this.state.isUserAdmin) || this.state.isUserDataScientist}
            isDevOpsUser={(this.state.isUserProjectAdmin || this.state.isUserAdmin) || this.state.isDevOpsUser}
            isDetailPage={true}
            headerSection={
              <>
                {(this.isArchiveAvailable() && (
                  <Col className="projectTitleButton">
                    <Button onClick={() => this.archiveProject()}><i className="icon-tag-status-archived" />{' Archive project '}{this.state.archivingProject && <Spinner />}</Button>
                  </Col>
                ))}
                {((this.state.isUserProjectAdmin || this.state.isUserAdmin) && this.state.isProjectArchive && this.state.projectDetail.projectMemberRequest.length == 0 && this.state.projectDetail.isActive) && (
                  <Col className="projectTitleButton">
                    <Button onClick={() => this.deleteProject()}><i className="icon-trash" />{' Delete project '}{this.state.deletingProject && <Spinner />}</Button>
                  </Col>
                )}
              </>
            }
          />
          <Container>
            <ClassicTitledTile title={(<h3>Quick Access</h3>)}>
              <Row className="accessButtons">
                <Col md={colWidthBtn}>
                  <span>
                    {(this.state.projectDetail.devOpsRepositoryUrl && (
                      <a className="projectDetailLink" href={this.state.projectDetail.devOpsRepositoryUrl} rel="noopener noreferrer" target="_blank" title="Version your code using git technology">
                        <Button variant="outline-primary"><img src={repo} alt="repo Logo" /> Repository</Button>
                      </a>
                    ))}
                  </span>
                </Col>
                <Col md={colWidthBtn}>
                  {(this.state.projectDetail.devOpsBoardUrl && (
                    <a className="projectDetailLink" href={this.state.projectDetail.devOpsBoardUrl} rel="noopener noreferrer" target="_blank" title="Organize your work in an agile way">
                      <Button variant="outline-primary"><img src={board} alt="board Logo"/> Board</Button>
                    </a>
                  ))}
                </Col>
                <Col md={colWidthBtn}>
                  {(this.state.projectDetail.azureInstanceUrl && (
                    <a className="projectDetailLink" href={this.state.projectDetail.azureInstanceUrl} rel="noopener noreferrer" target="_blank" title="Leverage AzureML power to share data, launch experiments, &#13;deploy compute intances and API etc.">
                      <Button variant="outline-primary"><img src={aml} alt="aml Logo"/> Workspace</Button>
                    </a>
                  ))}
                </Col>
                {(this.state.projectDetail.teamsUrl && (
                <Col md={colWidthBtn}>
                    <a className="projectDetailLink" href={this.state.projectDetail.teamsUrl} rel="noopener noreferrer" target="_blank" title="Share info and documents with project team and sponsors">
                      <Button variant="outline-primary"><img src={teams} alt="teams Logo"/> Teams</Button>
                    </a>
                </Col>
                ))}
              </Row>
            </ClassicTitledTile>
            <ClassicTitledTile title={(
              <h3>
                Virtuals machines{' '}
                {this.state.isUserDataScientist && (this.state.newCiFormState === "filling" ?
                  (
                    <span
                      className='projectDescriptionSaveBtn'
                      onClick={this.handleNewCiSubmit}
                    >
                      <i className='icon-cloud-upload' /><i className='icon-close-little' onClick={this.cancelNewCiCreation} />
                    </span>
                  ) : (
                    (this.state.newCiFormState == "creating") ? (
                      <Spinner />
                    ) : (
                      <i className='icon-pencil-edit' onClick={this.startNewCiCreation} title="Modify section" />
                    )
                  )
                )}
              </h3>
            )}>
              <Row>
                <Col sm={12}>
                  <Container>
                    <>
                      {(this.state.isUserDataScientist) ? formNewCi : null}
                      {(this.state.azureML.computeInstances.length) ? (
                        <Table
                          className='ciVmList'
                          header={[
                            { size: '10%', content: 'Status' },
                            { size: '15%', content: 'Name' },
                            { size: '10%', content: 'Cpu' },
                            { size: '10%', content: 'Gpu' },
                            { size: '12%', content: 'Ram' },
                            { size: '10%', content: 'Links' },
                            { size: true, content: 'Planned stop' },
                            { size: '5%', content: '' } //Delete
                          ]}

                          rows={
                            this.state.azureML.computeInstances.map((inst, i) => ({
                              //rowProps: ,
                              cells: [
                                (this.hasActionOnCi(inst) ? (
                                  null
                                ) : (this.isStatusError(inst.status) ? (
                                  <span key={i} className="glyphicon glyphicon-circle-empty-alert" >{inst.status}</span>
                                ) : (this.isStatusInProgress(inst.status) ? (
                                  <span key={i} className="glyphicon glyphicon-circle-empty-alert" ><Spinner />{inst.status}</span>
                                ) : (
                                  <Form.Check
                                    id={"custom-switch-" + i}
                                    key={i}
                                    type="switch"
                                    checked={inst.status === 'Running'}
                                    onChange={(e) => this.updateProjectComputeState(e, inst, i)}
                                    label=''
                                    title="Switch on/off the VM &#13;(WARNING: no confirmation will be asked)"
                                  />
                                )
                                )
                                )
                                ),
                                inst.name,
                                inst.vCpus,
                                inst.gpus,
                                (inst.memoryGB ? `${inst.memoryGB} Go` : ""),
                                ((inst.status === 'Running') ? (
                                  <span key={i}>
                                    <a href={inst.jupyterLabUrl} target="_blank" rel="noopener noreferrer"><img className='vm-service-icon' alt='JupyterLab' src={jupyterlab} /></a>{'\t'}
                                    <a href={inst.jupyterUrl} target="_blank" rel="noopener noreferrer"><img className='vm-service-icon' alt='Jupyter' src={jupyter} /></a>{'  '}
                                    <a href={inst.rStudioUrl} target="_blank" rel="noopener noreferrer"><img className='vm-service-icon' alt='RStudio' src={rstudio} /></a>
                                  </span>
                                ) : null
                                ),
                                ((this.hasActionOnCi(inst) || this.isStatusError(inst.status)) ? (
                                  null
                                ) : (
                                  <Container key={i}>
                                    <Row>
                                      <Col>
                                        <Form.Check
                                          {...(!this.state.isDevOpsUser && { disabled: 'disabled' })}
                                          type="switch"
                                          id={"custom-switch-shutdown-" + i}
                                          checked={inst.isAutoShutDownEnabled} // ? 'checked' : ''}
                                          onChange={(e) => this.updateProjectCIShutDown(e, inst, 'isAutoShutDownEnabled', e.target.checked)}
                                          label=""
                                          title="Do not forget to schedule the auto-shutdown"
                                        />
                                      </Col>
                                      <Col>
                                        {inst.isAutoShutDownEnabled &&
                                          <Form.Control
                                            as="select"
                                            {...(!this.state.isDevOpsUser && { readOnly: 'readOnly', 'disabled': 'disabled' })}
                                            required
                                            value={inst.autoShutDownUtcTime ? this.extractUtcHourFromDateTime(inst.autoShutDownUtcTime) : this.ciShutDownDefaultHour}//{this.state.projectCreationRequest.costcenterRefId}
                                            onChange={(e) => this.updateProjectCIShutDown(e, inst, 'autoShutDownUtcTime', e.target.value)}
                                          >
                                            {this.hours.map((c) => (
                                              <option key={c} value={c}>{c}</option>
                                            ))}
                                          </Form.Control>
                                        }
                                      </Col>
                                      <Col>
                                        {inst.isAutoShutDownEnabled ? 'UTC' : null}
                                      </Col>
                                    </Row>
                                  </Container>
                                ))
                                ,
                                (this.hasActionOnCi(inst) ? (
                                  null
                                ) : ((this.isStatusStable(inst.status)) ? (
                                  <i key={i} className="icon-trash" onClick={(e) => this.deleteProjectCompute(e, inst, i)} title="Delete your VM! &#13;(WARNING: no confirmation will be asked)" />
                                ) : null
                                ))
                              ],
                            }))
                          }
                        />
                      ) : (
                        <div>
                          <Row><Col md={true} /><img alt="no compute instances" src={nocomputeImg} /><Col md={true} /></Row>
                          <Row><Col md={true} />No compute instances<Col md={true} /></Row>
                        </div>
                      )
                      }

                    </>
                  </Container>
                </Col>
              </Row>
            </ClassicTitledTile>
            <ClassicTitledTile title={(<h3>Last commits</h3>)}>
              <Row>
                <Col sm={8}>
                  {(this.state.azureDevOps.lastCommits.length) ?
                    (
                      <Table
                        header={[
                          { size: '21%', content: 'Author' },
                          { size: true, content: 'Comment' },
                          { size: '30%', content: 'Time' },
                        ]}
                        rows={
                          this.state.azureDevOps.lastCommits.slice(0, 3).map((commit) => ({
                            rowProps: { onClick: () => window.open(commit.link, '_blank'), title: 'Open DevOps commit', className: 'routerlink' },
                            cells: [
                              commit.authorName,
                              commit.comment + (commit.commentTruncated ? '...' : ''),
                              moment(commit.timestamp).format('DD/MM/YYYY HH:mm'),
                            ],
                          }))
                        }
                      />
                    ) : (
                      <div>
                        <Row><Col md={true} /><img alt="no commits" src={nocommitImg} /><Col md={true} /></Row>
                        <Row><Col md={true} />No previous commit<Col md={true} /></Row>
                      </div>
                    )
                  }
                </Col>
              </Row>
            </ClassicTitledTile>
          </Container>
        </>
      );
    }

    return (
      <MainPagesLayout className='ProjectDetailPage'>
        <Breadcrumb className={'breadCrumb'}>
          <Breadcrumb.Item {...LinkTo('/', true)}>
            <img alt="CoDAI" src={logo} />
          </Breadcrumb.Item>
          {projectId && (
            <Breadcrumb.Item {...LinkTo(`/project/${projectId}`, true)}>
              {this.state.projectDetail ? this.state.projectDetail.name : 'Project'}
            </Breadcrumb.Item>
          )}
          <Breadcrumb.Item active>
            {'details view'}
          </Breadcrumb.Item>
        </Breadcrumb>
        {projectDetailPage}
      </MainPagesLayout>
    );
  }
}

export default ProjectDetailPage;
